var $fdb0616f309780b0$exports = {};
$fdb0616f309780b0$exports = {
    "Empty": `Vazio`
};


export {$fdb0616f309780b0$exports as default};
//# sourceMappingURL=pt-PT.module.js.map
